module.exports = __webpack_public_path__ + "img/Books.fb1e846a.jpg";